// React
import React from 'react'
// GraphQL
import { compose, graphql } from 'react-apollo'
// GraphQL queries
import { contactQuery } from '../../graphql/queries/contacts'
// GraphQL mutations
import { createContact, assignContactToUser, triggerSubscription, updateContact, deleteContact } from '../../graphql/mutations/contacts'
// Functions
import compatibility from '../../functions/relationship'
// Data
import { aspects } from '../../data/aspects'
// Components
import EntryForm from '../Home/EntryForm'
import Input from '../Display/Input'
import Loading from '../Display/Loading'
import Logo from '../Display/Logo'
import Modal from '../Display/Modal'
import CompleteAccess from '../Payment/CompleteAccess'
import Tab from './Tab'

class Contact extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			id: '',
			nameFirst: '',
			nameLast: '',
			birthDate: { day: 0, month: 0, year: 0 },
			birthPlace: { address: '', lat: 0, lng: 0 },
			birthTime: { hour: -1, minute: -1, pm: false, timezone: 'America/New_York', utcOffset: 0 },
			birthSigns: {
				sun: { degree: 0, minute: 0, name: '' },
				moon: { degree: 0, minute: 0, name: '' }
			},
			loading: { status: false, text: '' },
			modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null }, loading: false }
		}
	}

	componentWillMount() {
		// If existing contact has been called
		const { contact } = this.props
		if (contact) {
			const { id, nameFirst, nameLast, birthDate, birthPlace, birthTime, birthSigns } = contact
			this.setState({
				id,
				nameFirst,
				nameLast,
				birthDate,
				birthPlace,
				birthTime,
				birthSigns
			})
		}
	}


	// GRAPHQL
	updateBirthData = (birthDate, birthPlace, birthTime, birthSigns) => {
		const { id, nameFirst, nameLast } = this.state
		// If existing contact, update contact
		if (id) {
			this.props.updateContact({ variables: { id, nameFirst, nameLast, birthDate, birthPlace, birthTime, birthSigns } })
				.then(() => {
					this.props.redux.nav.setPage(birthSigns.moon.name, {
						name: birthSigns.moon.name, degree: birthSigns.moon.degree, minute: birthSigns.moon.minute
					})
				})
				.catch((err) => console.error(err))
		}
		// Create new contact
		else {
			this.props.createContact({
				variables: { nameFirst, nameLast, birthDate, birthPlace, birthTime, birthSigns }
			})
				.then(({ data }) => {
					const contactId = data.createContacts.id
					this.setState({ id: contactId })
					this.props.assignContactToUser({ variables: { userId: this.props.user.id, contactId } })
						.then(({ data }) => {
							const contactId = data.addToContactsForEachUser.contactsContacts.id
							// Trigger subscription
							this.props.triggerSubscription({ variables: { contactId, updateTrigger: new Date() } })
								.then(() => {
									this.props.redux.nav.setPage(birthSigns.moon.name, {
										name: birthSigns.moon.name, degree: birthSigns.moon.degree, minute: birthSigns.moon.minute
									})
								})
								.catch((err) => console.error(err))
						})
						.catch((err) => console.error(err))
				})
				.catch((err) => console.error(err))
		}
	}


	// MODALS
	closeModal = () => this.setState({ modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null }, loading: false } })


	// INPUT HANDLERS
	handleDelete = () => {
		this.setState({ loading: { status: true, text: 'Deleting...' } })
		const { id } = this.state
		// Only existing contact, not new contact
		if (id) {
			this.props.deleteContact({ variables: { id } })
				.then(({ data }) => {
					const { nameFirst, nameLast } = data.deleteContacts
					this.setState({
						loading: { status: false, text: '' },
						modal: {
							status: 'visible',
							title: 'Contact deleted',
							text: 'Your contact ' + nameFirst + ' ' + nameLast + ' has been deleted.',
							action: { text: 'Continue', func: () => {
								this.closeModal()
								this.props.redux.nav.setPage('')
							}},
							cancel: { text: '', func: () => null },
							loading: false
						}
					})
				})
				.catch((err) => console.error(err))

		}
	}

	handleInput = (name, value) => this.setState({ [name]: value })

	handleSelect = (e) => this.setState({ [e.name]: parseInt(e.newValue, 10) })


	render() {
		if (this.props.data.loading) {
			return <Loading status={true} text='loading...' />
		}
		// If user has reached maximum number of contacts, bring up Stripe payment instead...
		if (!this.props.data.loading && !this.props.contact && this.props.data.contactQuery.length >= 1 && !this.props.user.accountPaid) {
			return <CompleteAccess {...this.props} />
		}
		// ...otherwise, continue to add or edit contact.
		const {
			id,
			nameFirst,
			nameLast,
			birthDate,
			birthPlace,
			birthTime,
			birthSigns,
			loading,
			modal
		} = this.state
		const aspect = id ? compatibility(this.props.user.birthSigns.moon.name, birthSigns.moon.name).aspect : null
		return (
			<div>
				<Logo {...this.props} />
				<Tab {...this.props} />
				<Loading status={loading.status} text={loading.text} />
				<div className='capps-container'>
					<Modal
						status={modal.status}
						title={modal.title}
						text={modal.text}
						action={{ text: modal.action.text, func: modal.action.func }}
						cancel={{ text: modal.cancel.text, func: modal.cancel.func }}
						loading={modal.loading}
					/>
					{id &&
						<div>
							<div className='capps-header'>Compatibility</div>
							<div className='capps-height-10' />
							<div className='capps-flex-horiz-left'>
								<div className='capps-contactinfo'><span className={'capps-compatibility ' + aspects[aspect].color} /></div>
								<div className='capps-text bold'>{aspect}</div><div className='capps-text' style={{ marginLeft: '15px' }}>{aspects[aspect].keyword}</div>
							</div>
							<div className='capps-height-10' />
							<div className='capps-form'>
								{aspects[aspect].description}
							</div>
							<div className='capps-height-10' />
							<div className='capps-footer' onTouchTap={() => {
								setTimeout(() => {
									window.localStorage.setItem('MoonSignApp:compatibility', true)
									this.props.redux.nav.setPage('relationships')
								}, 20)
							}}>
								<span className='capps-link'>Relationship Compatibility</span>
							</div>
							<div className='capps-height-20' />
						</div>
					}
					<div className='capps-flex-horiz-center'>
						<Input
							label='First name'
							name='nameFirst'
							onChange={(name, value) => this.handleInput(name, value)}
							type='text'
							value={nameFirst}
						/>
						<Input
							label='Last name'
							name='nameLast'
							onChange={(name, value) => this.handleInput(name, value)}
							type='text'
							value={nameLast}
						/>
					</div>
					<center><div className='capps-text'>Enter {nameFirst ? nameFirst + '’s' : 'your'} date, time, and place of birth:</div></center>
					<div className='capps-height-10' />
					<EntryForm
						birthDate={birthDate}
						birthTime={birthTime}
						birthPlace={birthPlace}
						birthSigns={birthSigns}
						updateBirthData={(birthDate, birthPlace, birthTime, birthSigns) => this.updateBirthData(birthDate, birthPlace, birthTime, birthSigns)}
						contactId={id}
						nameFirst={nameFirst}
						handleDelete={this.handleDelete}
						{...this.props}
					/>
					<div className='capps-height-20' />
					<div className='capps-height-20' />
				</div>
			</div>
		)
	}
}

export default compose(
	graphql(createContact, { name: 'createContact' }),
	graphql(assignContactToUser, { name: 'assignContactToUser' }),
	graphql(triggerSubscription, { name: 'triggerSubscription' }),
	graphql(updateContact, { name: 'updateContact' }),
	graphql(deleteContact, { name: 'deleteContact' }),
	graphql(contactQuery, {
		options: ({ user }) => ({ variables: { contactFilter: { user: { id: user.id } } } })
	})
)(Contact)



// WEBPACK FOOTER //
// ./src/Components/Home/Contact.js